import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import {
  CaixasDeAlimentacao, CaixasDeAtendimentoHorizontalBalanceado,
  CaixasDeAtendimentoVertical
} from 'src/app/simulation/state/network-parameters.model.generated';

@Component({
  selector: 'app-applied-form',
  templateUrl: './applied-form.component.html',
  styleUrls: ['./applied-form.component.scss']
})
export class AppliedFormComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  types: CaixasDeAlimentacao | CaixasDeAtendimentoHorizontalBalanceado | CaixasDeAtendimentoVertical;

  @Input()
  formArray: FormArray;

  @Input()
  min = 0;

  form: FormGroup;

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      quantity: [this.types.length, [Validators.required, Validators.min(this.min)]],
    });

    this.form.valueChanges
      .pipe(debounceTime(500))
      .subscribe(v => {
        this.createTypes(v.quantity);
      });

    this.formArray.push(this.form);
  }

  plus() {
    const quantity = this.form.value.quantity + 1;
    this.updateQuantity(quantity);
  }

  minus() {
    const quantity = this.form.value.quantity - 1;
    this.updateQuantity(quantity);
  }

  private updateQuantity(quantity: number): void {
    this.form.patchValue({ quantity });
    this.createTypes(quantity);
  }

  private createTypes(quantity: number): any {

    if (this.types.length > quantity) {
      this.types.splice(quantity - 1, this.types.length);

    } else if (this.types.length < quantity) {
      const list = Array(quantity - this.types.length).fill({});
      this.types.push(...list);
    }
  }

}
